import type { ReactNode } from "react";
import { useParams } from "react-router-dom";

function Section({
  title,
  description,
  detail,
}: {
  title: string;
  description: string;
  detail?: string | undefined;
}): ReactNode {
  return (
    <section className="max-w-2xl">
      <h2 className="text-xl font-semibold">{title}</h2>
      <p className="mt-1 text-sm text-muted">{description}</p>
      {detail !== undefined && <p className="mt-3 font-mono text-sm">{detail}</p>}
    </section>
  );
}

export const ApiAndAccessScreen = (): ReactNode => (
  <Section
    title="API and access"
    description="Personal tokens, connected applications, and active sessions."
  />
);

export const FeaturesSettingsScreen = (): ReactNode => (
  <Section title="Features" description="Optional workspace features." />
);

export const TemplatesScreen = (): ReactNode => (
  <Section title="Templates" description="Document templates available to the workspace." />
);

export function TemplateScreen(): ReactNode {
  const { id } = useParams();
  return <Section title="Template" description="Edit a template." detail={id} />;
}
